import React from 'react';

interface ServiceTitleProps {
  children: React.ReactNode;
  className?: string;
  imageSrc: string;
}

const ServiceTitle: React.FC<ServiceTitleProps> = ({
  children,
  className,
  imageSrc,
}: ServiceTitleProps) => {
  return (
    <div className={`page-title ${className || ''}`}>
      <div className="px-0 service-page-title d-flex justify-content-center align-items-center">
        <img className='w-100' src={imageSrc} />
        <h1 className='position-absolute'>{children}</h1>
      </div>
    </div>
  );
};

export default ServiceTitle;